import React from 'react';
import Link from 'gatsby-link';

import Logo from '../Logo/index';
import './styles.scss';


const links = [
	{'label': 'About', path: '/about/'},
	{'label': 'Projects', path: '/projects/'},
	{'label': 'People', path: '/people/'},
	{'label': 'Contact', path: '/contact/'},
];

const Header = ({}) => {
	return (
		<header className={'header'}>
			<div className={'wrapper'}>
				<div className={'header-logo'}>
					<Link to="/">
						<Logo size={'small'} />
					</Link>
					<span>Merchants Partners</span>
				</div>
				<nav className={'nav'}>
					<ul>
						{links.map(link=> (
							<Link to={link.path} className={'nav-link'} activeClassName={'active'}>{link.label}</Link>
						))}
					</ul>
				</nav>
			</div>
		</header>
	)
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/index.jsx